<template>
	<ui-dialog :title="isEdit ? 'Editera Återförsäljare' : 'Ny Återförsäljare'" @submit="onSubmit" @close="onClose">
		<ui-row>
			<ui-col cols="6">
				<ui-text-field class="mb-4" label="Namn" v-model="formData.name" :rules="$validator('base/required')" />
				<ui-textarea label="Beskrivning" v-model="formData.description" />
			</ui-col>
			<ui-col cols="6">
				<div class="is-flex">
					<ui-text-field ref="emailsRef" class="mb-4 company-form__email-input" label="E-Post för bristrapport" v-model="emailToAdd" :rules="$validator('base/email')"/>
					<ui-btn style="position: relative; top: 24px;" @click.stop="addEmail">Lägg till</ui-btn>
				</div>
				<div class="form__list">
					<div class="form__list-item" v-for="email in emails" :key="email">
						<span>{{ email }}</span>
						<span class="icon" @click="removeEmail(email)">
							<i class="fas fa-times"/>
						</span>
					</div>
				</div>
			</ui-col>
		</ui-row>


		<hr style="height: 1px; background-color: #4d535d;"/>

		<h4 class="is-size-5 mb-2">Uppgifter för automatiska mailuskick</h4>
		<ui-row>
			<ui-col cols="6">
				<ui-text-field label="Namn" v-model="formData.contactName" />
			</ui-col>
			<ui-col cols="6">
				<ui-text-field label="Telefonnummer" v-model="formData.contactNumber" />
			</ui-col>
			<ui-col cols="6">
				<ui-text-field label="E-Postadress" v-model="formData.contactEmail" :rules="$validator('base/email')" />
			</ui-col>
		</ui-row>

		<template #actions>
			<div class="is-flex is-justify-content-space-between">
				<div class="is-flex is-align-items-center">
					<ui-alert v-if="error" error>{{ error }}</ui-alert>
					<ui-alert v-if="successMessage" success>{{ successMessage }}</ui-alert>
				</div>
				<ui-btn class="is-info" :loading="isPending" type="submit" icon="fa-save">Spara</ui-btn>
			</div>
		</template>
	</ui-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

const initalFormData = () => ({
	name: '',
	description: '',
	flawEmailRecipient: '',
	contactName: '',
	contactNumber: '',
	contactEmail: ''
});

export default {
	props: {
		isEdit: {
			type: Boolean,
			default: false
		}
	},

	data: () => ({
		formData: initalFormData(),
		emails: [],
		emailToAdd: '',

		error: '',
		successMessage: '',
		isPending: false
	}),

	computed: {
		...mapGetters('user', ['getActiveCustomer', 'getActiveCompany']),

		getTitle() {
			if (this.isRoot) {
				return 'Ny Kund';
			}

			return this.isEdit ? 'Editera Nivå' : 'Ny Nivå';
		}
	},

	created() {
		if (this.isEdit) {

			// eslint-disable-next-line no-unused-vars
			const {id, ...companyObj} = this.getActiveCompany;
			this.formData = {
				...this.formData,
				...companyObj
			};

			this.emails = companyObj.flawEmailRecipient ? companyObj.flawEmailRecipient.split(';') : [];
		}
	},

	methods: {
		...mapActions('user', ['setActiveCompany']),

		removeEmail(email) {
			this.emails = this.emails.filter(e => e !== email);
		},

		addEmail() {
			if(this.$refs.emailsRef.validateInput() || this.emailToAdd.length === '') {
				return;
			}

			if (this.emails.some(x => x === this.emailToAdd)) {
				this.emailToAdd = '';
				
				return;
			}

			this.emails = [this.emailToAdd, ...this.emails];
			this.emailToAdd = '';
		},

		onSubmit() {
			this.error = '';
			this.successMessage = '';

			if (this.isEdit) {
				this.update();

				return;
			}

			this.create();
		},

		async create() {
			try {
				await this.$services.company.createCompany({
					...this.formData,
					flawEmailRecipient: this.emails.join(';')
				}, {
					throwException: true,
					loading: val => {
						this.isPending = val;
					}
				});

				this.successMessage = 'Återförsäljaren skapades utan problem.';
				this.formData = initalFormData();
				this.emails = [];

				this.$emit('on-update');
			} catch (error) {
				this.error = error.message;
			}
		},

		async update() {
			try {
				const data = await this.$services.company.update(this.getActiveCompany.id, {
					...this.formData,
					flawEmailRecipient: this.emails.join(';')
				}, {
					throwException: true,
					loading: val => {
						this.isPending = val;
					}
				});

				this.setActiveCompany(data);

				this.successMessage = 'Återförsäljaren uppdaterades utan problem.';

				this.$emit('on-update');
			} catch (error) {
				this.error = error.message;
			}
		},

		onClose() {
			this.$emit('close');
		}
	}
};
</script>

<style lang="scss">


.company-form__email-input {
	flex-grow: 1;
	margin-right: 1rem;

	> label {
		white-space: nowrap;
	}
}
</style>
